/**
 * Big Toe Energy — live countdowns for the [countdown-midnight] and [countdown-tom-midnight] tokens.
 *
 * Everything uses the visitor's own clock and time zone:
 * - "midnight": time left until tonight's midnight (max 24 h)
 * - "tom-midnight": time left until tomorrow's midnight, the end of tomorrow (max 48 h)
 *
 * One clock for every countdown on the page. The time left is recalculated from the real time on
 * every tick, so it stays exact after the tab slept or the phone was locked.
 */

const SELECTOR = '[data-bte-cd]';

/** @param {number} n */
const pad = (n) => String(n).padStart(2, '0');

/**
 * @param {string | undefined} kind
 * @param {number} now
 */
function targetFor(kind, now) {
  const target = new Date(now);
  target.setHours(24, 0, 0, 0); // next local midnight, safe with daylight saving changes
  if (kind === 'tom-midnight') target.setDate(target.getDate() + 1);
  return target.getTime();
}

/** @param {number} ms */
function format(ms) {
  const total = Math.max(0, Math.floor(ms / 1000));
  const hours = Math.floor(total / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  const seconds = total % 60;
  return `${pad(hours)} : ${pad(minutes)} : ${pad(seconds)}`;
}

let timer = 0;

function tick() {
  const now = Date.now();
  for (const el of document.querySelectorAll(SELECTOR)) {
    if (!(el instanceof HTMLElement)) continue;

    // Lock width before first text change (placeholder uses widest digits)
    if (!el.hasAttribute('data-bte-cd-ready')) {
      el.style.display = 'inline-block';
      el.style.minWidth = el.offsetWidth + 'px';
    }

    const text = format(targetFor(el.dataset.bteCd, now) - now);
    if (el.textContent !== text) el.textContent = text;

    if (!el.hasAttribute('data-bte-cd-ready')) {
      el.setAttribute('data-bte-cd-ready', '');
      el.style.visibility = '';
    }
  }
  window.clearTimeout(timer);
  // Wake up just after the next full second
  timer = window.setTimeout(tick, 1020 - (Date.now() % 1000));
}

if (!window.bteCountdownStarted) {
  window.bteCountdownStarted = true;
  tick();
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) tick();
  });
  // Theme editor: sections are re-rendered when settings change
  document.addEventListener('shopify:section:load', tick);
}
